import { render, staticRenderFns } from "./Q4.vue?vue&type=template&id=3d2927fe&"
import script from "./Q4.vue?vue&type=script&lang=ts&"
export * from "./Q4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports